export default __webpack_public_path__ + "static/media/No6.ed10843b.jpg";